// extracted by mini-css-extract-plugin
export var container = "layout-module--container--7fcf9";
export var content = "layout-module--content--98b71";
export var main = "layout-module--main--f99ca";
export var minename = "layout-module--minename--61b96";
export var searchbar = "layout-module--searchbar--5e08f";
export var sidebar = "layout-module--sidebar--2fd89";
export var topbar = "layout-module--topbar--220c4";